routing.$inject = ['$stateProvider'];

export default function routing($stateProvider) {
    $stateProvider
        .state('campaign', {
            url: "/campaign",
            abstract: true
        })

        .state('campaign.index', {
            url: "",
            controller: 'CampaignCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/campaign/index.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:CAMPAIGN:INDEX'
            }
        })

        .state('campaign.folder', {
            url: "/folder/{folder}/view/{view}/page/:page",
            controller: 'CampaignCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/campaign/index.html'),
            params: {
                page: { squash: true, value: null }
            },
            ncyBreadcrumb: {
                parent: 'campaign.index',
                skip: true
            }
        })

        .state('campaign.create', {
            url: "/create/:type",
            controllerProvider: ($stateParams) => {
                return $stateParams.type == "text_message" ? 'CampaignSmsEditorCtrl' : 'CampaignMailEditorCtrl';
            },
            controllerAs: 'edit',
            template: ($stateParams) => {
                if ($stateParams.type == "text_message") {
                    return require('../../../views/campaign/sms-editor.html');
                }

                return require('../../../views/campaign/create.html');
            },
            params: {
                type: { squash: true, value: null }
            },
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:CREATE',
                parent: 'campaign.index'
            }
        })

        .state('campaign.edit', {
            url: '/{id}/edit/{type}',
            controllerProvider: ($stateParams) => {
                return $stateParams.type == "text_message" ? 'CampaignSmsEditorCtrl' : 'CampaignMailEditorCtrl';
            },
            controllerAs: 'edit',
            template: ($stateParams) => {
                if ($stateParams.type == "text_message") {
                    return require('../../../views/campaign/sms-editor.html');
                }

                return require('../../../views/campaign/create.html');
            },
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:EDIT',
                parent: 'campaign.index'
            }
        })

        .state('campaign.guide', {
            url: '/guide',
            controller: 'CampaignCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/availability/guide.html'),
            ncyBreadcrumb: {
                label: 'Tillgänglighetsguide',
                parent: 'campaign.index'
            }
        })

        .state('campaign.summary', {
            url: '/:id/summary/:type',
            controller: 'CampaignSummaryCtrl',
            controllerAs: 'summary',
            template: require('../../../views/campaign/summary.html'),
            params: {
                type: { squash: true, value: null }
            },
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:CAMPAIGN:SUMMARY',
                parent: 'campaign.index'
            }
        })

        .state('campaign.show', {
            url: '/{messageType}/{id}/statistics/{folder}',
            controller: 'StatisticsCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/statistic/statistics.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:CAMPAIGN:SHOW',
                parent: 'campaign.index'
            }
        })

        .state('campaign.transactionshow', {
            url: '/{messageType}/transactional/{id}/statistics/{folder}',
            controller: 'StatisticsCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/statistic/statistics.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:CAMPAIGN:SHOW',
                parent: 'campaign.index'
            }
        })

        .state('campaign.abTestStatistics', {
            url: '/abTest/{id}/statistics/{folder}',
            controller: 'AbTestStatisticsCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/statistic/ab-test.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:AB:STATISTICS',
                parent: 'campaign.index'
            }
        })
};